import { useMutation, useQueryClient } from 'react-query';
import { getInvoiceDataUseCases } from '@subscriptions/composition';

/**
 * Hook for deleting invoice data.
 *
 * @returns Mutation result for deleting invoice data
 */
export const useDeleteInvoiceData = () => {
  const queryClient = useQueryClient();
  const { deleteInvoiceData } = getInvoiceDataUseCases();

  return useMutation<void, Error, string>((invoiceDataUuid) => deleteInvoiceData.execute(invoiceDataUuid), {
    onSuccess: () => {
      queryClient.invalidateQueries(['subscriptions', 'invoice-data', 'list']);
    },
  });
};
